import React, { useEffect, useState, useRef } from "react";
import Menu from '../../components/sturtural/Menu';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from "primereact/dialog";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { Dropdown } from 'primereact/dropdown';
import { Toast } from "primereact/toast";
import { storage } from "../../helpers/storage";



const destinos = [
    { label: 'CT', value: 1 },
    { label: 'Este usuario', value: 2 },
]

const INIT_FORM = {
    municipio: null,
    localidad: null,
    ct: '',
    nombre: '',
    apellidoP: '',
    apellidoM: ''
}

const FiltroCT = () => {
    const [form, setForm] = useState(INIT_FORM);
    const [loading, setLoading] = useState(false);
    const [loadingPendientes, setLoadingPendientes] = useState(false);
    const [dataErrors, setDataErrors] = useState(false);
    const [alumnosDialog, setalumnosDialog] = useState(false);
    const [dialogSuccess, setDialogSuccess] = useState(false);
    const [dialogWarn, setDialogWarn] = useState(false);
    const [escuela, setEscuela] = useState(null);
    const [message, setMessage] = useState('');
    const perfil = storage.get('perfilid');
    const navigate = useNavigate();
    const [destino, setDestino] = useState(destinos[0].value);
    const [getMunicipio, setGetMunicipio] = useState([])
    const [getLocalidad, setGetLocalidad] = useState([])

    const ciclo = storage.get('ciclo')
    const toast = useRef(null);


    useEffect(() => {
        if (![17, 1, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        helpHttp().post(`${BASE_API}Escuela/CargarMunicipios`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            setForm({ ...form, municipio: res[0] })
            setGetMunicipio(res)
        })
    }, [])

    useEffect(() => {
        if (form.municipio !== null) {
            helpHttp().post(`${BASE_API}Escuela/CargarLocalidades/${form.municipio.IdMunicipio}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                let items = res
                // items.unshift({ IdLocalidad: 0, Localidad: 'Todos' })
                setForm({ ...form, localidad: items[0] })
                setGetLocalidad(items)
            })
        }
    }, [form.municipio])

    const validateForm = (data) => {
        let errors = {};

        // if (!data.ct.trim()) {
        //     errors.ct = "El campo (ct) es requerido"
        // }
        if (!data.nombre.trim()) {
            errors.nombre = "El campo (nombre) es requerido"
        }
        if (!data.apellidoP.trim()) {
            errors.apellidoP = "El campo (apellido paterno) es requerido"
        }

        return errors;
    }

    const footerAlumno = () => {
        return (
            <div className="grid">
                <div className=" col-12 text-center" style={{ color: '#505050' }}>
                    {loadingPendientes && <label>Enviando a pendientes...</label>}
                </div>
                <div className="col-12 text-right">
                    <Button className="p-button-outlined" disabled={loadingPendientes} label="Cancelar" onClick={() => { setalumnosDialog(!alumnosDialog) }}></Button>
                    <Button className="p-button" loading={loadingPendientes} label="Enviar" onClick={() => handleConfirmar()}></Button>
                </div>
            </div>
        )
    }

    const footerSuccess = () => {
        return (
            <React.Fragment>
                <Button className="p-button" disabled={loadingPendientes} label="Aceptar" onClick={() => { setDialogSuccess(!dialogSuccess) }}></Button>
            </React.Fragment>
        )
    }

    const footerWarn = () => {
        return (
            <React.Fragment>
                <Button className="p-button" disabled={loadingPendientes} label="Aceptar" onClick={() => { setDialogWarn(!dialogWarn) }}></Button>
            </React.Fragment>
        )
    }

    const handleSubmitAlmListaPendientes = (e) => {
        e.preventDefault();

        setDataErrors(validateForm(form));

        if (Object.keys(dataErrors).length === 0) {
            if (form.nombre && form.apellidoP) {
                setLoading(true)
                const arrConsulta = {
                    Opcion: "1",
                    CT: form.ct,
                    IdNivel: 0,
                    IdTurno: 0,
                    Grado: "",
                    Grupo: "",
                    parametroExtras: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}, "IdMunicipio": ${form.municipio.IdMunicipio}, "IdLocalidad": ${form.localidad.IdLocalidad}}]`
                }

                helpHttp().post(`${BASE_API}Entrega/postSpdAlmConfirmarCTPendientes`, {
                    body: arrConsulta,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.ITEMS[0].Total !== null) {
                        setalumnosDialog(true)
                        setEscuela(res.ITEMS[0]);
                    } else {
                        setDialogWarn(true);
                        setMessage(res.ITEMS[0].mensaje);
                    }
                    setLoading(false)
                })
            }
        }


    }

    const handleConfirmar = () => {
        setLoadingPendientes(true);
        const arrConsulta = {
            Opcion: null ? "1" : destino,
            CT: form.ct,
            IdNivel: 0,
            IdTurno: 0,
            Grado: "",
            Grupo: "",
            NombreTutor: form.nombre,
            ApellidoPat: form.apellidoP,
            ApellidoMat: form.apellidoM,
            IdUsuario: storage.get('id'),
            parametroExtras: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}, "IdMunicipio": ${form.municipio.IdMunicipio}, "IdLocalidad": ${form.localidad.IdLocalidad}}]`

        }
        helpHttp().post(`${BASE_API}Entrega/postEnviarPendientesCT`, {
            body: arrConsulta,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS.Respuesta) {
                // setDialogSuccess(true);
                toast.current.show({ severity: 'success', summary: "Éxito", detail: res.ITEMS.Mensaje, life: 5000 });
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.Mensaje, life: 5000 })
            }
            setalumnosDialog(false);
            setLoadingPendientes(false);

        })
    }

    return (
        <>
            <Menu link='' />
            <Toast ref={toast} />
            <div className="card grid">
                <div className="col-12">
                    <div>
                        <h3>Enviar a pendientes</h3>
                        <form onSubmit={handleSubmitAlmListaPendientes}>
                            <div className="grid">
                                <div className="p-fluid col-12 md:col-4 lg:col-4">
                                    <label htmlFor="municipio">Municipio:</label>
                                    <Dropdown id="municipio" name="municipio" filter options={getMunicipio} optionLabel="Municipio" value={form.municipio} onChange={(e) => setForm({ ...form, municipio: e.target.value })} className={dataErrors.municipio && 'p-invalid'} />
                                    {dataErrors.municipio && <small className="p-error">{dataErrors.municipio}</small>}
                                </div>
                                <div className="p-fluid col-12 md:col-4 lg:col-4">
                                    <label htmlFor="localidad">Localidad:</label>
                                    <Dropdown id="localidad" filter name="localidad" options={getLocalidad} optionLabel="Localidad" value={form.localidad} onChange={(e) => setForm({ ...form, localidad: e.target.value })} className={dataErrors.localidad && 'p-invalid'} />
                                    {dataErrors.localidad && <small className="p-error">{dataErrors.localidad}</small>}
                                </div>
                                <div className="p-fluid col-12 md:col-4 lg:col-4">
                                    <label htmlFor="ct">CT:</label>
                                    <InputText id="ct" name="ct" value={form.ct} onChange={(e) => setForm({ ...form, ct: e.target.value })} placeholder="Ingrese un Centro de Trabajo" className={dataErrors.ct && 'p-invalid'} />
                                    {dataErrors.ct && <small className="p-error">{dataErrors.ct}</small>}
                                </div>
                                <div className="hidden p-fluid col-12 md:col-4 lg:col-4">
                                    <label htmlFor="destino">Destino:</label>
                                    <Dropdown id="destino" name="destino" value={destino} options={destinos} onChange={(e) => setDestino(e.target.value)} optionLabel="label" optionValue='value' placeholder="Elige un destino" />
                                </div>
                                <div className="p-fluid col-12 md:col-4 lg:col-4">
                                    <label htmlFor="nombre">Tutor:</label>
                                    <InputText id="nombre" name="nombre" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} placeholder="Ingrese nombre" className={dataErrors.nombre && 'p-invalid'} />
                                    {dataErrors.nombre && <small className="p-error">{dataErrors.nombre}</small>}
                                </div>
                                <div className="p-fluid col-12 md:col-4 lg:col-4 md:mt-4 lg:mt-4">
                                    <InputText id="apellidoP" name="apellidoP" value={form.apellidoP} onChange={(e) => setForm({ ...form, apellidoP: e.target.value })} placeholder="Ingrese apellido paterno" className={dataErrors.apellidoP && 'p-invalid'} />
                                    {dataErrors.apellidoP && <small className="p-error">{dataErrors.apellidoP}</small>}
                                </div>
                                <div className="p-fluid col-12 md:col-4 lg:col-4 md:mt-4 lg:mt-4">
                                    <InputText id="apellidoM" name="apellidoM" value={form.apellidoM} onChange={(e) => setForm({ ...form, apellidoM: e.target.value })} placeholder="Ingrese apellido materno" className={dataErrors.apellidoM && 'p-invalid'} />
                                </div>

                            </div>
                            <div className="p-dialog-footer">
                                <div className=" border-top-1 surface-border pt-3 text-right">
                                    <Button type='submit' name="button-folio" id="button-folio" disabled={loading} icon={(loading && 'pi pi-spin pi-spinner')} label="Enviar" />
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

            <Dialog visible={alumnosDialog} header='CONFIRMACIÓN' draggable={false} closable={false} className="w-full lg:w-6 p-3" footer={footerAlumno}>
                {escuela !== null &&
                    <div className="grid m-2 ml-3 mb-0" >
                        <div className="col-2 text-center mt-8 pb-0" >
                            <i className="pi pi-exclamation-triangle text-6xl md:text-8xl lg:text-8xl" style={{ color: '#9b2f3e' }} />
                        </div>
                        <div className="col-8 text-center" >
                            <div className="font-bold">
                                <div>
                                    {
                                    !form.ct.trim() ? 
                                    <><label className="text-2xl block">Municipio: {form.municipio.Municipio}</label>
                                    <label className="text-xl block">Localidad: {form.localidad.Localidad}</label>  
                                    </>                                                                     
                                    :
                                    <label className="text-2xl block">CT: {form.ct.toUpperCase()}</label>
                                     }
                                </div>
                                <label className="text-l block">Tutor: {form.nombre} {form.apellidoP} {form.apellidoM}</label>
                            </div>
                            <div className="mt-5">
                                <label className="text-m block">Total alumnos: {escuela.Total}</label>
                                <label className="text-m font-bold block" style={{ color: '#9b2f3e' }}>Alumnos con tallas válidas: {escuela.TotalPendientes}</label>
                            </div>
                            <div className="mt-5">
                                <label className="text-m block">Esto podría generar sobrecarga al sistema,</label>
                                <label className="text-m block">¿está seguro de enviar {escuela.TotalPendientes} alumnos a pendientes?</label>
                            </div>
                            {loadingPendientes &&
                                <div className="col-12 text-center pb-0">
                                    <ProgressSpinner style={{ width: '7rem' }} />
                                </div>}
                        </div>
                        <div className="col-2" ></div>
                    </div>}
            </Dialog>

            <Dialog visible={dialogSuccess} header='CONFIRMACIÓN' draggable={false} closable={false} className="w-full lg:w-6" footer={footerSuccess}>
                <div className="grid m-2 ml-3">
                    <div className="col-2 text-center mt-5">
                        <i className="pi pi-check text-6xl md:text-8xl lg:text-8xl" style={{ color: 'green' }} />
                    </div>
                    <div className="col-10 text-center -ml-8 mt-6">
                        <div className="font-bold">
                            <label className="text-2xl block">Alumnos enviados exitosamente</label>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={dialogWarn} header='CONFIRMACIÓN' draggable={false} closable={false} className="w-full lg:w-6" footer={footerWarn}>
                <div className="grid m-2 ml-3">
                    <div className="col-3 text-center mt-5">
                        <i className="pi pi-exclamation-triangle text-6xl md:text-8xl lg:text-8xl" style={{ color: '#cc8925' }} />
                    </div>
                    <div className="col-9 text-center -ml-8 mt-6">
                        <div className="font-bold">
                            <label className="text-2xl block">{message}</label>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default FiltroCT;